<template>
  <div class="broadcast">
		<div class="header">
			<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4D/rB4ChmKyrp6AGutRAAALxM_JPcA420.png" />
			<div class="title">直播倒计时</div>
			<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4D/rB4ChmKyrp6AGutRAAALxM_JPcA420.png" />
		</div>
		<van-count-down :time="countDownTime">
			<template #default="timeData">
				<div class="countdown-content">
					<span class="block">{{ timeData.days }}</span>
					<span class="space">天</span>
					<span class="block">{{ timeData.hours }}</span>
					<span class="space">时</span>
					<span class="block">{{ timeData.minutes }}</span>
					<span class="space">分</span>
					<span class="block">{{ timeData.seconds }}</span>
					<span class="space">秒</span>
				</div>
			</template>
		</van-count-down>
		<div class="button" :class="{noActive: !btnTate}">{{ btnTate ? '立即预约' : '无法预约'}}</div>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	props: {
		comData: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	computed: {
		countDownTime() {
			return moment(this.comData.liveReserveTime).valueOf() - moment().valueOf();
		},
		btnTate() {
			return new Date().getTime() < new Date(this.comData.liveReserveTime).getTime()
		}
	},
	data() {
		return {
			timeData: {}
		}
	},
	methods: {
    onChange(e) {
      this.timeData = e;
    },
	}
}
</script>

<style lang="stylus" scoped>
	.broadcast {
		width: 269px;
		height: 119px;
		background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4E/rB4ChWKyrbiANJcLAADa8LMvqQo621.png');
		background-size: 100% 100%;
		margin: 0 auto;
		margin-top: 10px;
		overflow: hidden;
		.header {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 18px;
			color: #FFFDF9;
			margin-top: 5px;
			.title {
				margin: 0 10px;
			}
			.icon1 {
				width: 13px;
				height: 13px;
			}
		}
		.countdown-content {
			display: flex;
			justify-content: center;
			color: #FFFFFF;
			font-size: 21px;
			font-weight: 600;
			margin-top: 20px;
			.space {
				color: #FFFFFF;
				font-size: 9px;
				margin: 0 5px;
			}
		}
		.button {
			width: 81px;
			height: 22px;
			color: #FE5F4F;
			font-size: 12px;
			text-align: center;
			line-height: 22px;
			border-radius: 11px;
			margin: 10px auto;
			background: #FFDFA0;
		}
		.noActive {
			color: #999
			background: #ccc;
		}
	}
</style>